/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import { Sounds } from '@tmna-ct/ipapps-core-js';
import styles from './styles';

const SoundServices = ({ t, classes }) => {
  const sound = new Sounds();
  const { container, separation } = classes;
  return (
    <div className={container}>
      <h3 className={separation}>{t('screens.Beep.title')}</h3>
      <p className={separation}>{t('screens.Beep.description')}</p>
      <Button variant="contained" className={separation} onClick={() => sound.decision()}>
        {t('screens.Beep.decision')}
      </Button>
      <Button variant="contained" className={separation} onClick={() => sound.notice()}>
        {t('screens.Beep.notice')}
      </Button>
      <Button variant="contained" className={separation} onClick={() => sound.failure()}>
        {t('screens.Beep.failure')}
      </Button>
    </div>
  );
};

SoundServices.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withTranslation()(withStyles(styles)(SoundServices));
